export const ACTION_SAVE_FEE_PAYER_PAGINATED = 'ACTION_SAVE_FEE_PAYER_PAGINATED';
export const ACTION_SAVE_FEE_PAYER_DETAILS = 'ACTION_SAVE_FEE_PAYER_DETAILS';
